import { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { InputText } from "primereact/inputtext";
import { Dropdown } from 'primereact/dropdown';
import { Link } from "react-router-dom";
import { Checkbox } from 'primereact/checkbox';

export default function EmployeeRightBar(props) {
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(()=>{
    setOpen(true)
  },[props?.value])

  const [selectedCity, setSelectedCity] = useState(null);
  const cities = [
      { name: 'New York', code: 'NY' },
      { name: 'Rome', code: 'RM' },
      { name: 'London', code: 'LDN' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' }
  ];

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4">
                      <button
                        type="button"
                        className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                        onClick={() => setOpen(false)}
                      >
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex h-full bg{#F5F6F7} flex-col overflow-y-scroll bg-white py-2 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                         Create New 
                      </Dialog.Title>
                      <p>Employee</p>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                       <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">First name</label>
                          <div className="mt-2">
                           <InputText type="name" value=""  placeholder="Type Here" className="w-full placeholder:text-[#667085] h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Last Name</label>
                          <div className="mt-2">
                           <InputText type="name" value=""  placeholder="Type Here" className="w-full placeholder:text-[#667085] h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Email</label>
                          <div className="mt-2">
                           <InputText type="name" value=""  placeholder="Type Here" className="w-full placeholder:text-[#667085] h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Department</label>
                          <div className="mt-2">
                          <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={cities} optionLabel="name" 
                            placeholder="Select" className="w-full h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Date of joining</label>
                          <div className="mt-2">
                           <InputText type="date" value=""  placeholder="Select date" className="w-full placeholder:text-[#667085] h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Role</label>
                          <div className="mt-2">
                          <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={cities} optionLabel="name" 
                            placeholder="Select" className="w-full h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Manager</label>
                          <div className="mt-2">
                          <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={cities} optionLabel="name" 
                            placeholder="Select" className="w-full h-10" />
                          </div>
                      </div>
                      <div className="mb-1 mt-4">
                          <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Send employee Handbook</label>
                          <div className="mt-2">
                            <div className="flex align-items-start mt-3">
                                <Checkbox inputId="checks1" name="Yes" value="checks" onChange={e => setChecked(e.checked)} checked={checked} />
                                <label htmlFor="checks1" className="ml-2 text-[1vw] me-4">Yes</label>
                                <Checkbox inputId="checks2" name="No" value="checks1" onChange={e => setChecked(e.checked)} checked={checked} />
                                <label htmlFor="checks2" className="ml-2 text-[1vw]">NO</label>
                            </div>
                          </div>
                      </div>
                      <div className="grow flex justify-end gap-3 mb-3 mt-3">
                       <Link to="/" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]">Cancel</Link>
                       <button  className="custmBtn blue radius8 text-center">Create</button>
                       </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
